<script setup>
import {defineProps} from "vue";
import {useRouter} from 'vue-router';
const router = useRouter();

const props = defineProps({
  pictures: {
    type: Array,
    required: true,
  },
  importEquip: {
    type: Map
  },
  total: {
    type: Number
  }
});

function newsDetail(id) {
  router.push({name: 'NewsDetail', params: {id: id}});
}
</script>

<template>
  <div>
    <!--  首图-->
    <el-row>
      <el-col class="gothamBold" :offset="3"
              style="text-align: left;margin-top: 3rem;margin-bottom: 2rem;font-weight: bold">
        <span class="profile-title">COMPANY</span>
        <br>
        <span class="company_font_blue profile-title">NEWS</span>
        <br>
        <div class="puHuiTi-regular" style="font-size: 2rem;margin-top: 0.5rem;font-weight: lighter">
          公司新闻
        </div>

      </el-col>
      <el-col :offset="3" :span="19"
              @click="newsDetail(props.importEquip.id)"

              style="position: relative;background-color:white;display: flex; align-items: center; justify-content: space-between;">
        <!-- 右侧图片部分 -->
        <el-image
            style="flex: 1.5; height: 25rem;"
            :src="props.importEquip.img_url"
            fit="cover"
        />
        <!-- 左侧文字部分 -->
        <div class="puHuiTi-Medium"
             style="flex: 1; padding-right: 2.5rem;text-align: left;padding-left: 5rem;align-self:start">
          <div style="margin-top: 2rem; color: #979797;">{{ props.importEquip.date }}</div>
          <div style="font-size: 1.5rem; margin-top: 2rem">{{ props.importEquip.title }}</div>
          <div class="puHuiTi-regular news-content">{{ props.importEquip.content }}</div>
          <div class="company_font_blue" style="position:absolute;bottom: 2rem">点此进入 ></div>
        </div>


      </el-col>
    </el-row>

    <!--重复图-->
    <el-row>
      <el-col
          v-for="(row, rowIndex) in props.pictures"
          :key="rowIndex"
          :offset="rowIndex%4 === 0 ? 3 : 1"
          :span="4"
          style="margin-top: 1.2rem;background-color: white;position: relative;height: 24rem"
          @click="newsDetail(row.id)"

      >
        <el-image
            style="width: 100%;height: 14rem"
            :src="row.img_url"
            fit="cover"
        />
        <div style="text-align: left;">
          <div class="puHuiTi-Medium" style="margin: 1.2rem;font-size: 1rem">
            {{ row.title }}
          </div>
          <div>
            <span style="position: absolute;bottom: 1.2rem;margin-left: 1.2rem;color: #979797">{{ row.date }}</span>
            <span style="position:absolute;right: 1.2rem;bottom: 1.2rem" class="company_font_blue"> > </span>
          </div>

        </div>
      </el-col>
      <div style="width: 100%">
        <el-pagination background layout="prev, pager, next" :page-size="8" :total="props.total"/>
      </div>
    </el-row>
  </div>
</template>

<style scoped>

.news-content {
  font-size: 1rem;
  margin-top: 1.2rem;
  overflow: hidden; /* 隐藏超出部分 */
  display: -webkit-box; /* Flexbox 布局 */
  -webkit-box-orient: vertical; /* 设置为垂直布局 */
  -webkit-line-clamp: 7; /* 限制显示两行 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */

}
</style>